<template>
  <div>
    <v-card class="progress-container" v-if="initialLoading">
      <v-progress-circular :size="120" color="primary" indeterminate></v-progress-circular>
    </v-card>
    <div v-else>
      <v-layout v-if="!acl.isWorker()">
        <v-flex xs8>
          <router-link :to="{ name:'form-fill', params: { schemaId: $route.params.schemaId }}" class="dropdown-item">
            <v-btn>
              <v-icon small fab block color="green darken-2" style="color: #efefef">add</v-icon>
            </v-btn>
          </router-link>
        </v-flex>
        <v-flex xs1>
          <v-btn @click="(byUser = !byUser) & queryForms()" :class="{active : byUser}">
            <v-icon small fab block>person</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs3 v-if="state == states.COMPLETED">
          <Upload />
          <v-btn @click="printAll()">
            <v-icon :disabled="!docAvailable" small fab block color="blue-grey darken-2" style="color: #efefef">print</v-icon>
          </v-btn>
          <v-btn @click="confirmAll()">
            <v-icon small fab block color="orange darken-4" style="color: #efefef">check</v-icon>
          </v-btn>
          <v-btn @click="printAllCsv()">
            <v-icon small fab block color="green darken-3" style="color: #efefef">receipt</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="!acl.isWorker()">
        <v-flex xs4 pa-2>
          <v-menu v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="dateFrom" :label="`${$t('form.search.from')}`" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="dateFrom" @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-menu v-model="menuTo" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="dateTo" :label="`${$t('form.search.to')}`" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="dateTo" @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout v-if="!acl.isWorker()">
        <v-flex xs4 pa-2>
          <v-select :items="templates" item-text="name" return-object :menu-props="{ maxHeight: '400' }" :label="`${$t('form.template')}`" v-model="template"></v-select>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-select :items="['PDF', 'DOCX']" :menu-props="{ maxHeight: '400' }" :label="`${$t('form.print-format')}`" v-model="format"></v-select>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

      <FilterView v-if="!acl.isWorker()" v-on:change-condition="updateConditions($event)" ref="filtrComp"></FilterView>
      <v-layout v-if="!acl.isWorker()">
        <v-flex xs4 pa-2>
          <v-select item-text="name" item-value="value" :items="states.states" @change="queryForms" :label="`${$t('schema.list.forms')}`" v-model="state"></v-select>
        </v-flex>
        <v-flex offset-xs7 xs1>
          <v-btn small :class="{active : editable}" @click="editable=!editable">
            <v-icon small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="records" :loading="updateLoading" :rows-per-page-text="tableTranslations.rowsPerPageText" :no-data-text="tableTranslations.noDataText" :no-results-text="tableTranslations.noResultsText"
                    :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination" :total-items="totalAmount" class="elevation-1">
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="narrow-header">
              <span class="span-blcok"> ID </span>
            </th>
            <th v-for="(header,index) in props.headers" :key="header.text+'_'+index" class="text-overflow header">
              <span class="span-blcok"> {{ header.text }} </span>
              <v-tooltip top v-if="hasDescription(header.value)">
                <template v-slot:activator="{ on :  on }">
                  <v-icon style="margin: -1px 5px;" class="center" color="blue darken-3" small v-on="on">info</v-icon>
                </template>
                <span>{{ formField(header.value).description }}</span>
              </v-tooltip>
            </th>

            <th class="narrow-header">
              <span class="span-blcok"> {{$t('states.state')}} </span>
            </th>
            <th class="narrow-header">
              <span class="span-blcok"> {{$t('archive.edit')}} </span>
            </th>
            <th class="narrow-header">
              <span class="span-blcok"> {{$t('form.to-file')}} </span>
            </th>
            <th class="narrow-header">
              <span class="span-blcok"> {{ $t('form.delete.header') }} </span>
            </th>
          </tr>
        </template>
        <template v-if="showSummary" slot="footer">
          <tr class="text-xs-center">
            <td v-for="(sum,key) in summaryNumericFields" :key="key" class="text-overflow text-xs-center" style="background-color:#e6ffe6;text-align: center;vertical-align: middle;">
              <span class="text-xs-center span-blcok" style="margin-top:30px"> {{ sum.value }} </span>

            </td>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :class="{ 'unconfirmed': !isConfirmed(props.item) }" @dblclick="confirmForm(props.item)">
            <td :class="{ 'unvalidate': !isValidate(props.item, header.value) }" class="text-overflow" v-for="(header, index) in formHeaders" :key="index">

              <table-view :context="createContext(props.item)" v-if="header.type === fieldType.TABLE" :table="formField(header.value)" :form_id="props.item.id" :rows_amount="props.item[header.value].data" @loading="updateLoading = $event" />

              <div v-else-if="header.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>

              <div v-else-if="header.type === fieldType.SIGNATURE">
                <img v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 " @click="openImage(props.item[header.value].data,'image/png')" class="imageField"
                     :src="'data:image/png;base64,'+props.item[header.value].data" />
                <div v v-else>Brak</div>
              </div>

              <div v-else-if="header.type === fieldType.PHOTO">
                <img v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 " @click="openImage(props.item[header.value].data,'image/jpg')" class="imageField"
                     :src="'data:image/jpg;base64,'+props.item[header.value].data" />
                <div v-else>Brak</div>
              </div>

              <div v-else-if='header.type === fieldType.ARCHIVE'>
                <Archive v-if="props.item[header.value].data != null " :edit="editable" :archive="props.item[header.value].data" />
                <div v-else>Brak</div>
              </div>


              <div v-else-if='header.type === fieldType.RELATED '>
                <Related :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
              </div>

              <div v-else-if='header.type === fieldType.DEPEND '>
                <Depend :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
              </div>

              <div v-else-if="header.type === fieldType.CONFIRMATION">
                <v-tooltip v-if="isConfirmed(props.item)" top>
                  <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon class="light-green--text">check_circle_outline</v-icon> {{ props.item[header.value].confirmed_by }}
                  </span>
                  </template>
                  <span>{{ props.item[header.value].confirmed_at }}</span>
                </v-tooltip>
                <v-icon v-else @click="confirmForm(props.item)" class="red--text pointer">highlight_off</v-icon>
              </div>

              <div v-else-if='header.type === fieldType.CHECKBOX'>
                <Checkbox :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                          v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
              </div>

              <div v-else-if='header.type === fieldType.RADIO'>
                <Radio :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                       v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
              </div>


              <div v-else>
                <CustomField :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                             v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation">
                </CustomField>
              </div>

            </td>
            <td style="width:100px" class="text-xs-center">
              <State :id="props.item.id" :state="props.item.state" />
            </td>
            <td>
              <router-link :to="{ name:'form-edit', params: { schemaId: $route.params.schemaId, formId: props.item.id  }}" class="dropdown-item">
                <v-btn small fab>
                  <v-icon small fab block color="green darken-2" style="color: #efefef">edit</v-icon>
                </v-btn>
              </router-link>
            </td>
            <td style="width:100px" class="text-xs-center">
              <v-btn class="center" :disabled="!docAvailable || !isConfirmed(props.item)" small fab block color="blue-grey darken-2" @click="toFile(props.item)">
                <v-icon style="color: #efefef">print</v-icon>
              </v-btn>
            </td>
            <td style="width:100px" class="text-xs-center">
              <v-btn class="center" color="deep-orange darken-3" fab small block dark @click="deleteForm(props.item.id, props.index)">
                <v-icon dark>delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <FormStats :schema="$store.state.forms.schema" class="marrgin-stats"></FormStats>

  </div>
</template>

<script>
import http from '@/plugins/http'
import Csv from '@/plugins/printer/Csv'
import fieldType from '@/enums/fieldType'
import states from '@/enums/states'
import TableView from './view/TableView'
import FormStats from "../stats/FormStats";
import FilterView from './view/FilterView'
import CustomField from './view/CustomField'
import Checkbox from './view/Checkbox'
import Radio from './view/Radio'
import Archive from "./view/Archive"
import Related from "./view/Related"
import Depend from "./view/Depend"
import State from "./State"
import FormAdapter from '@/plugins/FormAdapter'
import SummaryCalculator from '@/plugins/SummaryCalculator'
import Context from '@/plugins/Context'
import Upload from './Upload'
import schemaType from "@/enums/schemaType";
import Cookies from "js-cookie";
import Acl from "@/plugins/Acl"

export default {
  components: {
    FormStats,
    TableView,
    FilterView,
    CustomField,
    Archive,
    Related,
    Depend,
    State,
    Checkbox,
    Radio,
    Upload
  },
  computed: {
    summaryNumericFields() {
      return this.summaryCalculator.getSummary(this.records)
    },
    docAvailable() {
      return this.template && this.template.hasOwnProperty('id') !== undefined && this.template.id > 0
    },
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    fields() {
      return this.$store.state.forms.schema.fields
    },
    formHeaders() {
      let adapter = new FormAdapter(this.$store.state.forms.schema);
      return adapter.getHeaders();

    },
    headers() {
      return this.formHeaders.slice(1) //delete id header, ii is added manualy

    },
    totalAmount() {
      return this.$store.state.forms.amount
    },
    records() {
      let showFullName = Cookies.get('fullnameautor') == 'true'
      let schema = this.$store.state.forms.schema
      let adapter = new FormAdapter(this.$store.state.forms.schema, showFullName);
      adapter.schema = this.$store.state.forms.schema
      adapter.loadForms(this.$store.state.forms.results)
      return adapter.getRecords();
    },
    fieldType() {
      return fieldType
    },
    confirmation() {
      let firstRecord = this.records.find(() => true)
      if (firstRecord) {
        return firstRecord.hasOwnProperty('confirmation')
      }
      return false
    },
    pagination: {
      get: function() {
        return this.$store.state.formPagination
      },
      set: function(value) {
        this.$store.commit('setFormPagination', value)
      }
    },
    itemTrigger() {
      return [this.pagination, this.dateFrom, this.dateTo]
    }
  },
  data() {
    return {
      acl: new Acl(),
      showSummary: false,
      editable: false,
      byUser: false,
      searchPhrase: "",
      dateFrom: "",
      dateTo: "",
      state: 1,
      menuFrom: false,
      menuTo: false,
      initialLoading: true,
      updateLoading: false,
      templates: [],
      template: null,
      format: 'PDF',
      fieldsCondition: {},
      summaryFields: {},
      states: states,
      Context,
      schemaType
    }
  },
  methods: {
    updateConditions(conditions) {
      this.fieldsCondition = conditions
      this.queryForms()
    },
    isValidate(result, order) {
      if (result[order] != undefined && result[order].validation != undefined && order >= 1)
        return result[order].validation.pass

      return true;
    },
    updateField(idForm, field, header, value) {
      let schemaField = this.getSchemaField(header.value)
      let idSchema = this.$route.params.schemaId
      let payload = {
        idForm,
        idSchema,
        schemaField,
        value
      }

      this.$store.dispatch("updateFieldValue", payload)
          .then(() => {
            this.$store.commit('setSnack', {
              message: this.$t('form.update.success-message'),
              color: 'success'
            })
          }).catch(() => {
        this.$store.commit('setSnack', {
          message: this.$t('form.update.error-message'),
          color: 'danger'
        })
      })
    },
    createContext(records) {
      return Context.createFullFormContext(this.fields, records)
    },
    getSchemaField(order) {
      return this.$store.state.forms.schema.fields.find(field => field.order == order)
    },
    deleteForm(id, index) {
      this.$confirm(this.$t('form.delete.confirmation'))
          .then(res => {
            if (res) {
              this.updateLoading = true
              this.$store.dispatch('deleteForm', {
                schema_id: this.$route.params.schemaId,
                form_id: id,
                index
              })
                  .then(() => {
                    this.updateLoading = false
                    this.$store.commit('setSnack', {
                      message: this.$t('form.delete.success-message'),
                      color: 'success'
                    })
                  })
                  .catch(() => {
                    this.updateLoading = false
                    this.$store.commit('setSnack', {
                      message: this.$t('form.delete.error-message'),
                      color: 'danger'
                    })
                  })
            }
          })
    },
    confirmForm(row) {
      if (!this.isConfirmed(row)) {
        this.$confirm(this.$t('form.confirm.confirmation', {
          created_by: row.created_by,
          created_at: row.created_at
        }))
            .then(res => {
              if (res) {

                this.$store.dispatch('confirmForm', {
                  schema_id: this.$route.params.schemaId,
                  form_id: row.id
                })
                    .then(() => {
                      this.updateLoading = false
                      this.$store.commit('setSnack', {
                        message: this.$t('form.confirm.success-message'),
                        color: 'success'
                      })
                    }).catch(() => {
                  this.updateLoading = false
                  this.$store.commit('setSnack', {
                    message: this.$t('form.confirm.error-message'),
                    color: 'danger'
                  })
                })
              }
            })
      }
    },
    confirmAll() {
      http.post('form/confirm/all', {
        schema_id: this.$route.params.schemaId
      }).then(() => {
        this.$store.commit('setSnack', {
          message: this.$t('form.confirm.success-message'),
          color: 'success'
        })
        this.queryForms()
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: this.$t('form.confirm.error-message'),
          color: 'danger'
        })
      })
    },
    isConfirmed(record) {
      if (this.confirmation) {
        return record.confirmation.hasOwnProperty('confirmed_by') && record.confirmation.confirmed_by !== null
      }
      return true
    },
    toFile(form) {
      http({
        url: '/form/' + form.id + '/print/' + this.template.id + '/' + this.format.toLowerCase(),
        method: 'GET',
        responseType: 'blob'
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.template.name + ' - ' + form.created_at + ', ' + form.created_by + '.' + this.format.toLowerCase());
            document.body.appendChild(link);
            link.click();
          });
    },
    printAll() {
      let url = '/form/print/all/' + this.template.id + '/' + this.format.toLowerCase() + '?'

      if (this.dateFrom) {
        url += 'from=' + this.dateFrom + '&'
      }
      if (this.dateTo) {
        url += 'to=' + this.dateTo
      }

      http({
        url: url,
        method: 'GET',
        responseType: 'blob'
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.template.name + ' - records' + '.zip');
            document.body.appendChild(link);
            link.click();
          });
    },
    printAllCsv() {
      http.get('forms/' + this.$route.params.schemaId + "/full/1").then((result) => {
        let csv = new Csv(this.$store.state.forms.schema)
        csv.printHeaders().loadFormRecods(result.data).save()
      })
    },
    canShowSummary() {
      // tymczasowo wyl. przeniesc to do innego komponentu i dodac do opcji czy ma byc pokazywane
      this.$store.state.forms.schema.fields.forEach((field) => {
        if (field.type == "numberXXX") {
          this.summaryCalculator = new SummaryCalculator(this.$store.state.forms.schema)
          this.showSummary = true
          return
        }
      })
    },
    queryForms() {
      return this.$store.dispatch('loadForms', {
        schema_id: this.$route.params.schemaId,
        pagination: this.pagination,
        state: this.state,
        by_user: this.byUser,
        condition: Object.assign({
          from: this.dateFrom,
          to: this.dateTo
        }, this.fieldsCondition)
      }).then(() =>{
        this.initialLoading = false})
    },
    formField(order) {
      return this.$store.getters.formField(order)
    },
    hasDescription(filedOrder) {
      let field = this.formField(filedOrder)

      if (field != undefined && field.description != null && field.description.length > 0)
        return true
    },
    openImage(base64, type) {
      let win = window.open("")
      win.document.write('<img  src=\'data:' + type + ";base64," + encodeURI(base64) + "'></img>");
    }
  },
  watch: {
    itemTrigger() {
      if (!this.initialLoading) {
        this.updateLoading = true
        this.queryForms()
            .then(() => {
              this.updateLoading = false
            })
      }
    }
  },
  created() {
    this.$store.commit('setDefaultFormPagination')
    this.initialLoading = true
    this.queryForms()
    this.$store.dispatch('loadRelatedSchemas')
    this.$store.dispatch('loadAgencies')

    Promise.all([
      http.get('templates/' + this.$route.params.schemaId),
    ]).then(([templates]) => {
      this.templates = templates.data
      if (typeof this.templates[0] !== 'undefined') {
        this.template = this.templates[0]
      }
      this.canShowSummary()
    }).catch(()=>{

    })
  }
}
</script>

<style scoped>
.unconfirmed {
  background: repeating-linear-gradient(45deg,
  rgba(0, 0, 0, 0.1),
  rgba(0, 0, 0, 0.1) 10px,
  rgba(0, 0, 0, 0.15) 10px,
  rgba(0, 0, 0, 0.15) 20px);
}

.unvalidate {
  background-color: #ff4d4d !important;
}

.incorrect {
  text-decoration: underline red;
}

.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.imageField {
  height: 100px;
}

.text-overflow {
  text-align: center;
  word-wrap: break-word;
  align: center;
  vertical-align: middle;
}

.center {
  margin: 0 auto;
}

.span-blcok {
  display: inline-block;
  height: 50px;
  white-space: normal;
}

.header {
  width: 200px
}

.narrow-header {
  width: 70px;
}

.marrgin-stats {
  margin-top: 20px;
}

.active {
  background-color: #ccffcc !important;
}
</style>
